import { useState } from "react";
import { Link } from "react-router-dom";
import { useRequestPasswordReset } from "@/api/auth";
import { AgencyLogo } from "@/components/agency-logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const resetRequest = useRequestPasswordReset();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    resetRequest.mutate({ email }, { onSuccess: () => setSubmitted(true) });
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-background overflow-hidden">
      <div className="login-grid" />
      <div className="login-glow" />

      <div className="relative z-10 w-full max-w-sm rounded-2xl border border-border/60 bg-surface/90 p-8 shadow-elevated backdrop-blur-sm">
        <div className="mb-10 flex flex-col items-center gap-4">
          <AgencyLogo className="h-8 text-text-primary" />
          <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-text-muted">
            Password Reset
          </p>
        </div>

        {submitted ? (
          <div className="space-y-4 text-center">
            <p className="text-sm text-text-secondary">
              If an account with that email exists, a password reset link has been sent. Check your email.
            </p>
            <Link to="/login" className="text-sm font-medium text-accent hover:underline">
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="mb-1.5 block text-[11px] font-medium uppercase tracking-wider text-text-muted">
                Email
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
                autoFocus
              />
            </div>
            <Button type="submit" className="w-full" disabled={resetRequest.isPending}>
              {resetRequest.isPending ? "Sending..." : "Send Reset Link"}
            </Button>
            <div className="text-center">
              <Link to="/login" className="text-sm text-text-muted hover:text-text-primary">
                Back to Sign In
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
